// @ts-nocheck
import React from "react";
import config from "Config";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "!style-loader!css-loader!react-toastify/dist/ReactToastify.css";

import {
  Tooltip,
  Button,
  UncontrolledTooltip,
  Input,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";

import Responsive from "react-responsive";
import history from "Services/history";
import withState from "recompose/withState";
import mapProps from "recompose/mapProps";
import compose from "recompose/compose";
import render from "Utils/template_render";
import { geo_aggregations_lookup } from "Lookups";
import capitalizeSentence from "Utils/capitalizeSentence";

import { getChartsForDomainData } from "Components/Charts/componentFilter";

import logo from "Assets/img/geografia_logo.svg";

const STATE = config.admin_state_acronym.toLowerCase();
const client_logo_name =
  STATE === "qld" ? "client_logo.svg" : "client_logo.png";
const ClientLogo = require(`Assets/${STATE}/img/${client_logo_name}`);

const Desktop = (props) => <Responsive {...props} minWidth={992} />;
const MobileAndTablet = (props) => <Responsive {...props} maxWidth={991} />;

function sendEmailRequest({
  showFor,
  selectedDomain,
  selectedDomainValue,
  selectedYear,
  email,
}) {
  axios
    .post("https://dlgsc-v2-email-report.herokuapp.com/email-report", {
      showFor,
      selectedDomain,
      selectedDomainValue,
      selectedYear,
      email,
    })
    .then(
      (response) => {
        console.log(response);
        toast.dark(`\u{1F680} ${response.data}!`, {
          position: toast.POSITION.TOP_RIGHT
        });
      },
      (error) => {
        console.log(error);
      }
    );
}

const handleEmail = ({ showFor, aggregation, value, year }) => (_) => {
  const email = document.getElementById("email-address").value;
  const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (re.test(String(email).toLowerCase())) {
    [showFor, aggregation, value, year, email].log();

    sendEmailRequest({
      showFor,
      selectedDomain: aggregation,
      selectedDomainValue: value,
      selectedYear: year,
      email,
    });
  }
};

const SelectChartComponent = mapProps((props) =>
  (props.match.params.community ? "community" : "geo_aggregation").chain(
    (showFor) =>
      getChartsForDomainData(
        { ...props.tree.domain_data, ...props.match.params },
        showFor
      ).chain((filteredChartComponents) => ({
        ChartComponent:
          filteredChartComponents[props.match.params.category][
            props.match.params.subcategory
          ]["component"],
        filteredChartComponents,
        showFor,
        ...props,
      }))
  )
);

const addToolTipStateDoc = withState(
  "tooltipOpenDoc",
  "setTooltipOpenDoc",
  false
);
const addToolTipStatePdf = withState(
  "tooltipOpenPdf",
  "setTooltipOpenPdf",
  false
);

const HeadingTemplate = ({ aggregation, value, year, showFor }) =>
  ({
    reports_url: `https://s3-ap-southeast-2.amazonaws.com/${
      config.cartodb_username === "dlgc" ? "dlgsc/reports" : "dlgrma/reports"
    }`, // TODO: move to config
    file_name: `${
      config.cartodb_username
    }_${year}_${aggregation.toLowerCase()}_${value}`,
  }.chain(() => (
    <div className="row dark-header-clr">
      <div className="col-2" />
      <div id="details-title" className="col-5">
        {value} ({year})
      </div>
      <div className="col-3 align-self-end justify-content-end">
        <ToastContainer />

        <InputGroup size="sm">
          <Input id="email-address" placeholder="Your email" />
          <InputGroupAddon addonType="append">
            <Button
              onClick={handleEmail({ showFor, aggregation, value, year })}
              color="success"
            >
              Email report
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </div>
    </div>
  )));

const Heading = addToolTipStatePdf(addToolTipStateDoc(HeadingTemplate));

const DisclaimerTemplate = ({ geo_aggregation }) => (
  <div className="small text-muted">
    {render(config.disclaimer_template, {
      geo_aggregation: capitalizeSentence(
        geo_aggregations_lookup[geo_aggregation]
      ),
    })}{" "}
    <a href={config.abs_url} target="_blank" rel="noopener">
      click here
    </a>
    .
  </div>
);

const DetailsViewNavigation = (props) => (
  <React.Fragment>
    {Object.keys(props.filteredChartComponents).map((category) => (
      <ul className="list-unstyled" key={category}>
        <li>
          <h4>{category}</h4>
        </li>
        <ul className="list-unstyled">
          {Object.keys(props.filteredChartComponents[category]).map(
            (subcategory) => (
              <li key={subcategory}>
                <a
                  className={`list-link ${
                    subcategory == props.match.params.subcategory
                      ? "active"
                      : ""
                  }`}
                  onClick={() =>
                    history.push(
                      `${props.match.url
                        .split("/")
                        .slice(0, -2)
                        .concat([category, subcategory])
                        .join("/")}`
                    )
                  }
                >
                  {subcategory}
                </a>
              </li>
            )
          )}
        </ul>

        <hr />
      </ul>
    ))}
  </React.Fragment>
);

const Template = ({
  tree,
  match,
  showFor,
  ChartComponent,
  filteredChartComponents,
  showMobileNav,
  setShowMobileNav,
}) =>
  ChartComponent ? (
    <div id="details-view" className="lightblue pb-4">
      <TopMenu tree="" />

      {/* Breadcrumbs ... */}
      <div id="sub-header" className="p-3 dark-header-clr">
        <div onClick={(_) => history.push("/")} className="col-1">
          <i className="fa fa-arrow-left fa-2x" />
        </div>
        <div className="col-1" />
        <div className="col-8 p-0">
          {match.params.geo_aggregation
            ? geo_aggregations_lookup[match.params.geo_aggregation]
            : tree.domain_data.community}
        </div>
      </div>
      {/* Heading */}
      <Heading
        showFor={showFor}
        aggregation={
          showFor == "community"
            ? tree.domain_data.community || match.params.community
            : tree.domain_data.geo_aggregation || match.params.geo_aggregation
        }
        value={
          showFor == "community"
            ? tree.domain_data.community_value || match.params.community_value
            : tree.domain_data.geo_aggregation_value
                .replace(/_/g, " ")
                .replace(/\//g, "-") ||
              match.params.geo_aggregation_value
                .replace(/_/g, " ")
                .replace(/\//g, "-")
        }
        year={tree.domain_data.year}
      />

      <MobileAndTablet>
        <div className="row dark-header-clr details-content">
          {/* Example https://reactstrap.github.io/components/collapse/ */}
          <div className="col">
            <UncontrolledTooltip placement="right" target="mobileNavToggler">
              {showMobileNav ? "Hide Navigation" : "Show Navigation"}
            </UncontrolledTooltip>

            <Button
              id="mobileNavToggler"
              size="sm"
              color="light"
              onClick={(_) => setShowMobileNav(!showMobileNav)}
              style={{ marginBottom: "1rem", marginTop: "1rem" }}
            >
              <i className="fa fa-2x fa-bars" aria-hidden="true" />
            </Button>

            {/* TODO: Add Side Navigration here very similar to the Desktop Version, only showing when showMobileNav is true */}
            {showMobileNav ? (
              <div className="animated fadein">
                <DetailsViewNavigation
                  match={match}
                  filteredChartComponents={filteredChartComponents}
                />
              </div>
            ) : null}
          </div>
        </div>
        <div className="row white">
          <div className="col mt-4">
            <DetailsContent
              {...{
                tree,
                match,
                showFor,
                ChartComponent,
              }}
            />
          </div>
        </div>
      </MobileAndTablet>
      <Desktop>
        <SpecialLayout>
          <div className="row white details-content">
            {/* Side Navigration */}
            <div className="col-3">
              <DetailsViewNavigation
                match={match}
                filteredChartComponents={filteredChartComponents}
              />
            </div>

            {/* Details Content */}
            <div className="col-9">
              <DetailsContent
                {...{
                  tree,
                  match,
                  showFor,
                  ChartComponent,
                }}
              />
            </div>
          </div>
        </SpecialLayout>
      </Desktop>
    </div>
  ) : null;

const DetailsContent = ({ tree, match, showFor, ChartComponent }) => (
  <React.Fragment>
    <h4>
      {match.params.category} / {match.params.subcategory}
    </h4>

    <hr />

    <ChartComponent
      showFor={showFor}
      match={match}
      domain_data={tree.domain_data}
    />

    <hr />

    {showFor === "geo_aggregation" && 
    tree.domain_data.geo_aggregation !== "ste" &&
    tree.domain_data.year == "2016" &&
    match.params.subcategory === "Population Composition" ? (
      <DisclaimerTemplate geo_aggregation={tree.domain_data.geo_aggregation} />
    ) : null}
  </React.Fragment>
);
const SpecialLayout = ({ children }) =>
  (({ height = 150 }) => (
    <div className="col-2 d-flex flex-column">
      <div style={{ height }} className="row">
        <div className="col" />
      </div>
      <div style={{ flex: 1 }} className="row lightblue">
        <div className="col" />
      </div>
    </div>
  )).chain((SideColumn) => (
    <div
      style={{ flex: 1 }}
      className="dark-header-clr row pt-4 mb-4 align-items-stretch"
    >
      <SideColumn />
      <div className="col-8 white">
        <div className="p-3">{children}</div>
      </div>
      <SideColumn />
    </div>
  ));

const addToolTipState = withState("tooltipOpen", "setTooltipOpen", false);
const addMobileNavState = withState("showMobileNav", "setShowMobileNav", false);

const TopMenuTemplate = ({ tooltipOpen, setTooltipOpen }) => (
  <div
    id="topmenu"
    className="top-menu-bg-det black align-items-center justify-content-between"
  >
    <div className="mr-auto client_logo">
      <a
        className=""
        href={config.department_url}
        target="_blank"
        rel="noopener"
      >
        <img src={ClientLogo} />
      </a>
    </div>
    <div className="company_logo ml-auto company_logo">
      <a
        className="ml-auto"
        target="_blank"
        rel="noopener"
        href="http://geografia.com.au"
      >
        <img src={logo} />
      </a>

      <span
        style={{ cursor: "pointer" }}
        id="TooltipElem"
        onClick={(_) => history.push("/about")}
        className="fa-stack fa "
      >
        <i className="fa fa-circle-thin fa-stack-2x" />
        <i className="fa fa-info fa-stack-1x" />
      </span>
    </div>

    <Tooltip
      className="white"
      placement="left"
      isOpen={tooltipOpen}
      target="TooltipElem"
      toggle={(_) => setTooltipOpen(!tooltipOpen)}
    >
      Explanatory Notes
    </Tooltip>
  </div>
);

const TopMenu = addToolTipState(TopMenuTemplate);

module.exports = compose(SelectChartComponent, addMobileNavState)(Template);



// WEBPACK FOOTER //
// ./views/DetailsView.js